
import Vue from "vue";
import action from "@/components/ActionBarCom.vue";
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
export default Vue.extend({
  components: { action },
  data() {
    return {
      items: [] as any[],
      spanArr: [] as number[], // 存放每一行要合并的行数
      pos: 0, // 当前分组起始索引
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      const actionBar: any = this.$refs.action;
      const content = actionBar.getSearch();
      const ret: any = await DeviceRequestBill.GetKpiMethods(content, 1, 1000);
      this.items = ret.data;
      // 数据加载完成后，计算合并单元格数组
      this.calcSpanArr();
    },
    // 计算分组合并数组
    calcSpanArr() {
      this.spanArr = [];
      this.pos = 0;
      if (!this.items || this.items.length === 0) return;
      for (let i = 0; i < this.items.length; i++) {
        // 当前行
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 和上一行分组相同
          if (this.items[i].kpiSourceGroup === this.items[i - 1].kpiSourceGroup) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0); // 本行被合并，rowspan=0
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },
    spanMethod({ row, column, rowIndex, columnIndex }: any) {
      // 只合并第0列：kpiSourceGroup分组列
      if (columnIndex === 0) {
        const rowSpan = this.spanArr[rowIndex];
        return {
          rowspan: rowSpan,
          colspan: 1,
        };
      }
      // 其他列不合并
      return {
        rowspan: 1,
        colspan: 1,
      };
    },
  },
});
